import {useState,useEffect}  from "react";
import {   
    makeStyles,
    mergeClasses,
    Dialog,
    DialogSurface,
    DialogTitle,
    DialogBody,
    DialogActions,
    DialogContent,
    DialogTrigger,
    Button,
    TableBody,
    TableCell,
    TableRow,
    Table,
    TableHeader,
    TableHeaderCell,
    TableCellLayout,
    useFocusableGroup,
    tokens,
    Subtitle2,
    Textarea,
    Spinner,
    useToastController,
    } from "@fluentui/react-components";
import {
    EditRegular,
    DeleteRegular
} from "@fluentui/react-icons";
import TimePicker from './TimePicker';
import {IsCompleteTime, DifferenceInMinutes} from '../../services/TimeFunctions';
import { format } from "date-fns";
import {SetTimeEntryDetails} from '../../services/apiService';
import {useGlobalStatus} from '../../services/GlobalStatusProvider';
import { showErrorToast, showSuccessToast, TOASTER_ID } from "../../services/toastUtils";

const useStylesEditor = makeStyles({
    dialog: {
        width: '90vw',
        maxWidth: '1000px',
        padding: '1rem',
        overflowX: 'auto',
    },
    
    infobar :{
        color: tokens.colorBrandForeground1,
        backgroundColor: tokens.colorBrandBackground2,
        padding: '3px'
    }
});

export default function DayCombined(props) { 
    const [disableEntryFields, setDisableEntryFields] = useState(true);
    const{startLoad, endLoad, timesheetStatus, useStyles, loading}= useGlobalStatus();
    const globalStyles = useStyles();
    const [entry, setEntry]=useState({
            start:'',
            end: '',
            break:'',
            comments:'',
            totalMinutes: 0,
            id:0,
            startEndValidationState:'none',
            breakValidationState: 'none',
            isValid:false
    });
    const [open, setOpen] = useState(false);
    const [entryToDelete, setEntryToDelete] = useState(null);
    const [disableConfirmForAPI, setDisableConfirmForAPI] = useState(false);
    const { dispatchToast } = useToastController(TOASTER_ID);

    // Reset input fields when the dialog closes
    useEffect(() => {
        if (!props.dialogOpen) {
            setDisableEntryFields(true);
            clear(); 
        }
    }, [props.dialogOpen]);

    const focusableGroupAttr = useFocusableGroup({
        tabBehavior: "limited-trap-focus",
    });
    
    const styles = useStylesEditor();

    const handleRowEdit = (id)=> {
        setDisableEntryFields(false);
        setEntry(props.entries.find(q=> q[0].id === id)[0]);
    }

     const handleRowDelete = async (id)=> {
        startLoad();
        var entryToDelete = props.entries.find(q=> q[0].id === id)[0];
        // Delete from A23 DB
        var timeEntryDetail = {
            start:entryToDelete.start,
            end: entryToDelete.end,
            break:entryToDelete.break,
            comments:entryToDelete.comments,
            timeEntryDetailId:entryToDelete.id};
        
        var task = (props.entries.find(entryDay => entryDay[0].id === id) || [])[2] || null;
        var day = task.entryDays.find(entryDate => props.date.getTime() === entryDate.date.getTime()) || null;

        var date = format(day.date, "yyyy-MM-dd HH:mm:ss");
        let deletedBool = false;
        try {
            deletedBool = await SetTimeEntryDetails(task.taskId, date, timeEntryDetail, true);
            showSuccessToast(dispatchToast, "Successfully deleted entry");
        } catch {
            showErrorToast(dispatchToast, "Failed to delete entry");
        }

        if (deletedBool) {
            day = {
                ...day,
                entries: day.entries.filter(item => item.id !== id)
            };
              props.handleUpdateWeekView(task, day); 
        } else {
            showErrorToast(dispatchToast, "Failed to delete entry");
        }
        endLoad();
        props.handleDialogClose();
    }

    const handleDialogCancel = () =>{
        props.handleDialogClose();
    };

    
    const handleDialogAdd = async () =>{
        // Validate break format before submission
        const isValidBreak = entry.break === "" || /^([01]\d|2[0-3]):([0-5]\d)$/.test(entry.break);
        if (!isValidBreak) {
            setEntry(prev => ({
                ...prev,
                breakValidationState: "error"
            }));
            return;
        }

        startLoad();
        setDisableConfirmForAPI(true);
        var timeEntryDetail = {
            start:entry.start,
            end: entry.end,
            break:entry.break,
            comments:entry.comments,
            timeEntryDetailId:entry.id};
        
        var task = (props.entries.find(entryDay => entryDay[0].id === entry.id) || [])[2] || null;

        var date = format(props.date, "yyyy-MM-dd HH:mm:ss");
        let newid = null;
        try {
            newid = await SetTimeEntryDetails(task.taskId, date, timeEntryDetail, false);
            showSuccessToast(dispatchToast, "Successfully updated entry");
        } catch {
            showErrorToast(dispatchToast, "Failed to update entry");
        }
        var day = task.entryDays.find(entryDate => props.date.getTime() === entryDate.date.getTime()) || null;

        if(entry.id===0){
            //Add a new record
            if(!isNaN(newid)){
                entry.id= newid;
                day.entries.push(entry);
            }
        } else {
            const entryIndex = day.entries.findIndex(existingEntry => existingEntry.id === entry.id);
            if (entryIndex !== -1) {
                day.entries[entryIndex] = { ...day.entries[entryIndex], ...entry };
            }
        }

        endLoad();
        setDisableConfirmForAPI(false);
        props.handleDialogClose();
        props.handleUpdateWeekView(task, day);
        clear();
    };
    

const handleSetEntry = (source, value) => {
    var instance = { ...entry };

    switch (source) {
        case "Start":
            instance.start = value;
            break;
        case "End":
            instance.end = value;
            break;
        case "Break":
            instance.break = value;
            instance.breakValidationState = "none";
            break;
        default:
            if (value !== undefined) {
                instance.comments = value.value;
            }
            break;
    }

    // Perform the validation
    if (IsCompleteTime(instance.start) && IsCompleteTime(instance.end)) {
        var difference = DifferenceInMinutes(instance.end, instance.start);
        
        if (difference < 1) {
            instance.startEndValidationState = "error";
            instance.totalMinutes = 0;
            instance.isValid = false;
        } else {
            instance.startEndValidationState = "none";
            instance.totalMinutes = difference;
            instance.isValid = true;

            if (IsCompleteTime(instance.break)) {
                var total = DifferenceInMinutes(difference, instance.break);
                if (total < 1) {
                    instance.breakValidationState = "error";
                    instance.totalMinutes = 0;
                    instance.isValid = false;
                } else {
                    instance.breakValidationState = "none";
                    instance.totalMinutes = total;
                    instance.isValid = true;
                }
            }
        }

        var task = (props.entries.find(entryDay => entryDay[0].id === entry.id) || [])[2] || null;
        var day = task.entryDays.find(entryDate => props.date.getTime() === entryDate.date.getTime()) || null;

        // Overlap Validation using all entries across same day
        const allEntriesSameDay = [];
        props.timesheetData.forEach(client => {
            client.projects.forEach(project => {
                project.budgets.forEach(budget => {
                    budget.timecodes.forEach(timecode => {
                        timecode.entryDays.forEach(entryDay => {
                            if (new Date(entryDay.date).toISOString().split("T")[0] === new Date(day.date).toISOString().split("T")[0]) { 
                                allEntriesSameDay.push(...entryDay.entries);
                            }
                        });
                    });
                });
            });
        });
        
        let hasOverlap = allEntriesSameDay.some(existingEntry => {
            if (existingEntry.id !== instance.id) {
                return (
                    (instance.start >= existingEntry.start && instance.start < existingEntry.end) || 
                    (instance.end > existingEntry.start && instance.end <= existingEntry.end) || 
                    (instance.start <= existingEntry.start && instance.end >= existingEntry.end)
                );
            }
            return false;
        });

        if (hasOverlap) {
            instance.overlapValidationState = "error";
            instance.isValid = false;
        } else {
            instance.overlapValidationState = "none";
        }
    }
    setEntry(instance);
};

    const clear = ()=> {
        setEntry({
            start:'',
            end: '',
            break:'',
            comments:'',
            totalMinutes: 0,
            id:0,
            startEndValidationState:'none',
            breakValidationState: 'none',
            overlapValidationState: 'none',
            isValid:false
        });
    }

    const columns = [
        { columnKey: "project", label: "Project" },
        { columnKey: "task", label: "Task" },
        { columnKey: "start", label: "Start" },
        { columnKey: "end", label: "End" },
        { columnKey: "break", label: "Break" },
        { columnKey: "comments", label: "Comments" },
        { columnKey: "total", label: "Total" },
        { columnKey: "actions", label: "Actions" },
    ];
    
    const nonEditableColumns = [
        { columnKey: "project", label: "Project" },
        { columnKey: "task", label: "Task" },
        { columnKey: "start", label: "Start" },
        { columnKey: "end", label: "End" },
        { columnKey: "break", label: "Break" },
        { columnKey: "comments", label: "Comments" },
        { columnKey: "total", label: "Total" }
    ];

    return (
        <Dialog open={props.dialogOpen} onOpenChange={(e, { open }) => handleDialogCancel()}>
            <DialogSurface className={styles.dialog}>
                <DialogBody>
                    <DialogTitle>{props.date && format(props.date,'PPPP')} - Click on Row to Edit</DialogTitle>
                    <DialogContent>
                        {
                            <div>
                            <div className="entry-table-info">
                            <Table className="editor-approval-table">
                                <TableHeader>
                                    <TableRow>
                                        {(timesheetStatus ? columns : nonEditableColumns).map((column) => (
                                            
                                        <TableHeaderCell key={column.columnKey}>
                                            {column.label}
                                        </TableHeaderCell>
                                        ))}
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {
                                        props.entries && props.entries.map((entry)=>(
                                            <TableRow key={entry[0].id} onClick={()=> {timesheetStatus && handleRowEdit(entry[0].id)}}>
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {entry[1].projectName}
                                                    </TableCellLayout>
                                                </TableCell>
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {entry[2].taskName}
                                                    </TableCellLayout>
                                                </TableCell>
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {entry[0].start}
                                                    </TableCellLayout>
                                                </TableCell>
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {entry[0].end}
                                                    </TableCellLayout>
                                                </TableCell>
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {entry[0].break}
                                                    </TableCellLayout>
                                                </TableCell>
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {entry[0].comments}
                                                    </TableCellLayout>
                                                </TableCell>
                                                <TableCell>
                                                    <TableCellLayout>
                                                    {(Math.round(entry[0].totalMinutes / 60 * 100) / 100).toFixed(2)}hr
                                                    </TableCellLayout>
                                                </TableCell>
                                                {timesheetStatus &&
                                                <TableCell role="gridcell" {...focusableGroupAttr}>
                                                    <TableCellLayout>
                                                        <Button icon={<EditRegular/>} aria-label="Edit" onClick={()=> {handleRowEdit(entry[0].id)}}/>
                                                        <Dialog open={open} onOpenChange={(e, { open }) => setOpen(open)}>
                                                            <DialogTrigger disableButtonEnhancement>
                                                                <Button icon={<DeleteRegular />} aria-label="Delete" onClick={() => {setOpen(true); setEntryToDelete(entry[0].id);}} />
                                                            </DialogTrigger>
                                                            <DialogSurface>
                                                                <DialogBody>
                                                                    <DialogTitle>Confirmation</DialogTitle>
                                                                    <DialogContent>Are you sure you want to delete the entry?</DialogContent>
                                                                    <DialogActions>
                                                                        <Button className={globalStyles.buttonPrimary} onClick={() => { handleRowDelete(entryToDelete); setOpen(false); }}>Yes</Button>
                                                                        <Button appearance="secondary" onClick={() => setOpen(false)}>No</Button>
                                                                    </DialogActions>
                                                                </DialogBody>
                                                            </DialogSurface>
                                                        </Dialog>
                                                    </TableCellLayout>
                                                </TableCell>
                                                }
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                            </div>   
                            {
                                (props.entries && props.entries.length===0) &&
                                    <div className={mergeClasses('infobar-layout', styles.infobar)}><Subtitle2>There are no entries</Subtitle2></div>                                
                            }  

                            {timesheetStatus && 
                            <div className="editor-form">
                                    <div className="editor-format-tip">Enter in 24 hour format, 4 digits</div>
                                    <div className="editor-error-message">
                                        {entry.overlapValidationState === "error" ? "Time overlaps with another entry! " : ""}
                                        {entry.startEndValidationState === "error" ? "End time must be greater than start time! " : ""}
                                        {entry.breakValidationState === "error"  && "Break cannot be longer than work time or incorrect format!"}
                                    </div>
                                    <div className="entry-editing">
                                        <div className="entry-editing-1">
                                            <TimePicker
                                            key={"entry-start"}
                                            label={"Start"}
                                            value={entry.start}
                                            setValue={handleSetEntry}
                                            validationState={entry.overlapValidationState === "error" ? "error" : "none"}
                                            required={true}
                                            disabled={disableEntryFields}
                                            />
                                            <TimePicker
                                            key={"entry-end"}
                                            label={"End"}
                                            value={entry.end}
                                            setValue={handleSetEntry}
                                            validationState={entry.overlapValidationState === "error" ? "error" : entry.startEndValidationState}
                                            required={true}
                                            disabled={disableEntryFields}
                                            />
                                    
                                            <TimePicker
                                            key={"entry-break"}
                                            label={"Break"}
                                            value={entry.break}
                                            setValue={handleSetEntry}
                                            required={false}
                                            validationState={entry.breakValidationState}
                                            disabled={disableEntryFields}
                                            />
                                        </div>
                                            <div className="editor-total-hours">
                                                Total Hours
                                                <div>{(Math.round((entry.totalMinutes / 60) * 100) / 100).toFixed(2)}hr</div>
                                            </div>
                                    </div>
                                        
                                    Comments<Textarea style={{ width: "100%" }} value={entry.comments} onChange={handleSetEntry} disabled={disableEntryFields}/>
                                </div>
                            }
                        </div>
                        }
                    </DialogContent>
                    <DialogActions>
                    <DialogTrigger disableButtonEnhancement>
                        <Button 
                            appearance="secondary" 
                            onClick={handleDialogCancel}
                            >Cancel</Button>                    
                    </DialogTrigger>                        
                    <Button 
                        disabled={
                            (!props.dialogOpen) || !entry.isValid || disableConfirmForAPI
                        }
                        icon={loading? <Spinner size="tiny" /> : null}
                        className={globalStyles.buttonPrimary}
                        onClick={handleDialogAdd}
                    >Confirm</Button>
                </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    )
}